<template>
    <div class="form-info">
        <div class="form-row spacing">
            <div class="form-row" style="height: 88px">
                <div class="form-label">
                    <label class="required">指定审核人：</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-select placeholder="请选择" class="fl" v-model="userId" :clearable=true>
                        <el-option v-for="item in retailerStaffList" :key="item.name" :label="item.name" :value="item.userId"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import retailerApi from '../../api/retailer'

    export default {
        name: 'swb-appoint-auditor',
        desc: '制定审核人',
        data: function () {
            return {
                retailerStaffList: [],
                userId: null,
            }
        },
        created: function () {
            this.getStaffByComId();
        },
        methods: {

            getStaffByComId: function () {
                let self = this;
                let postData = {};
                retailerApi.getRetailerStaffListByComId(postData, function (result) {
                    if(result.type === "info") {
                        self.retailerStaffList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            getDlgResult: function () {
                let self = this;
                let result = {};
                if(self.userId == null) {
                    MsgBox.warning("必须选择审核人");
                    return false;
                }
                result.type = "info";
                result.data = self.userId;
                return result;
            }
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/retailer/AppointAuditor.vue